import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  Col,
  Row,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  ButtonDropdown,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  Label,
  Badge,
} from "reactstrap";
import Widget from "../../components/Widget/Widget.js";
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// import BootstrapTable from "react-bootstrap-table-next";
// import paginationFactory from 'react-bootstrap-table2-paginator';
// import MUIDataTable from "mui-datatables";
import moreIcon from "../../assets/tables/moreIcon.svg"; //

import s from "../tables/Tables.module.scss";
import mock from "../tables/mock.js";
import { ArrowsExpand, Projector } from "react-bootstrap-icons";
import Print from "../../assets/tables/Print.png"
import { css } from "@emotion/react";
import { ClockLoader } from "react-spinners";
import Printbutton from "../../assets/printer.png"
import { useHistory, Link, useParams } from 'react-router-dom';
import BaseAPI from '../../api/apiurl.js';
import PrintableProduct from './PrintableProduct';
import Select from "react-select";
import DatePicker from 'react-datepicker';



const Product = function () { 


  const [firstTable] = useState(mock.firstTable);
  const [secondTable] = useState(mock.secondTable);
  const [secondTableCurrentPage, setSecondTableCurrentPage] = useState(0); //
  const [tableDropdownOpen, setTableMenuOpen] = useState(false); //
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [projectname, setProject] = useState([]); // project droupdown
  const [selectedproject, setSelectedproject] = useState(null);
  const [location, setLocation] = useState([]); // location droupdown
  const [selectedlocation, setSelectedlocation] = useState(null);
  const [area, setArea] = useState([]); // Area droupdown
  const [selectedarea, setSelectedArea] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  const [productNo, setProductNo] = useState("");
  const [locationKey, setlocationKey] = useState(0);
  const [AreaKey, setAreaKey] = useState(0);



  const pageSize = 10;
const secondTablePagesCount = Math.ceil((data && data.length) ? data.length / pageSize : 0);

  const PaginationComponent = () => {
    const pagesToShow = 5;

    const startPage = Math.max(0, secondTableCurrentPage - Math.floor(pagesToShow / 2));
    const endPage = Math.min(secondTablePagesCount - 1, startPage + pagesToShow - 1);

    return (
      <Pagination className="pagination-with-border">
        <PaginationItem disabled={secondTableCurrentPage <= 0}>
          <PaginationLink
            onClick={(e) => setSecondTablePage(e, secondTableCurrentPage - 1)}
            previous
            href="#top"
          />
        </PaginationItem>
        {[...Array(endPage - startPage + 1)].map((_, i) => (
          <PaginationItem
            key={i}
            active={startPage + i === secondTableCurrentPage}
          >
            <PaginationLink onClick={(e) => setSecondTablePage(e, startPage + i)} href="#top">
              {startPage + i + 1}
            </PaginationLink>
          </PaginationItem>
        ))}
        <PaginationItem disabled={secondTableCurrentPage >= secondTablePagesCount - 1}>
          <PaginationLink
            onClick={(e) => setSecondTablePage(e, secondTableCurrentPage + 1)}
            next
            href="#top"
          />
        </PaginationItem>
      </Pagination>
    );
  };



  const setSecondTablePage = (e, index) => {
    e.preventDefault();
    setSecondTableCurrentPage(index);
  }

  const tableMenuOpen = () => {
    setTableMenuOpen(!tableDropdownOpen);
  } //

  const handleSearchInputChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const decodeBase64SVG = (base64Data) => {
    try {
      return decodeURIComponent(escape(window.atob(base64Data)));
    } catch (error) {
      console.error('Error decoding Base64 SVG:', error);
      return null;
    }
  };

  const handlePrint = (item) => {
    const printContent = `
      <html>
        <head>
          <title>Printable Product</title>
        </head>
        <body>
          <h2>QR Code Print</h2>
          <p>Product Code: ${item.productref}</p>
          <img
          src="data:image/png;base64,${item.prodqrcode}"
          alt="QR Code"
          style="max-width: 200px; max-height: 200px;"
        />
          <p>Product: ${item.productname}</p>
         
        </body>
      </html>
    `;

    const printWindow = window.open('', '_blank');
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
  };



  const fetchData = () => {
    const customerId = localStorage.getItem('customerid');
    const companyId = localStorage.getItem('companyid');

    if (!customerId || !companyId) {
      console.log('Missing customer ID or company ID.');
      return;
    }

    const url = `${BaseAPI}productlist`;
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customer_id: customerId, company_id: companyId })
    };

    fetch(url, requestOptions)
      .then((response) => response.json())
      .then((actualData) => {
        console.log(actualData);

        setData(actualData.data);
        console.log("response", data);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const filteredData = data.filter((item) => {
    // You can customize the condition based on your requirements
    return item.productref.includes(searchQuery);
  });

  const fetchproduct = async () => {
    try {
        const url = `${BaseAPI}serviceproduct`;
        const companyId = localStorage.getItem('companyid');
        const customerId = localStorage.getItem('customerid');
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                // You might need to add other headers if required (e.g., authorization headers)
            },
            body: JSON.stringify({
                company_id: companyId,
                customer_id: customerId
            }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok.');
        }

        const data = await response.json();
        setProject(data.data.map(item => ({ label: item.productname, value: item.id })));
    } catch (error) {
        console.error('Error:', error);
        // Handle the error here if needed
    }
};

const handleProlectChange = async (newValue) => {
  setSelectedproject(newValue);

  try {
    const productId = newValue && typeof newValue === 'object' ? newValue.value : null;

    if (productId) {
      
      setLocation([]);
      setSelectedlocation(null);
      setArea([]);
      setSelectedArea(null);
      setAreaKey(prevKey => prevKey + 1);
      setlocationKey(prevKey => prevKey + 1);

      
      await fetchloaction(productId);
    } else {
      console.error('Invalid or missing project ID');
    }
  } catch (error) {
    console.error('Error fetching tasks:', error);
    // Handle errors if needed
  }
};

const fetchloaction = async (productId) => {
  try {
      const url = `${BaseAPI}productlocationdrop`;
      const companyId = localStorage.getItem('companyid');
      const customerId = localStorage.getItem('customerid');
      const response = await fetch(url, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              // You might need to add other headers if required (e.g., authorization headers)
          },
          body: JSON.stringify({
              company_id: companyId,
              customer_id: customerId,
              product_id : productId,
          }),
      });

      if (!response.ok) {
          throw new Error('Network response was not ok.');
      }

      const data = await response.json();
      setLocation(data.data.map(item => ({  label: item.AssignDesc, value: item.id })));
  } catch (error) {
      console.error('Error:', error);
      // Handle the error here if needed
  }
};

const handleLocationChange = async (value) => {
  try {
    setSelectedlocation(value);

    console.log('Selected Location:', value); // Log the entire value for debugging

    const locationId = value && typeof value === 'object' ? value.value : null;
    console.log('Location ID:', locationId); // Log the locationId for debugging


    if (locationId) {
      setArea([]);
      setSelectedArea(null);
     
      setAreaKey(prevKey => prevKey + 1);

      
      await fetchArea(locationId);
    } 
    
    
    else {
      console.error('Invalid or missing location ID');
    }
  } catch (error) {
    console.error('Error fetching areas:', error);
    // Handle errors if needed
  }
};




const fetchArea = async (locationId) => {
  try {
      const url = `${BaseAPI}productareadrop`;
      const companyId = localStorage.getItem('companyid');
      const customerId = localStorage.getItem('customerid');
      const response = await fetch(url, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              // You might need to add other headers if required (e.g., authorization headers)
          },
          body: JSON.stringify({
              company_id: companyId,
              customer_id: customerId,
              location_id: locationId,
          }),
      });

      if (!response.ok) {
          throw new Error('Network response was not ok.');
      }

      const data = await response.json();
      setArea(data.data.map(item => ({ label: item.area, value: item.id })));
  } catch (error) {
      console.error('Error:', error);
      // Handle the error here if needed
  }
};

const handleSearch = () => {
  const customerId = localStorage.getItem('customerid');
  const companyId = localStorage.getItem('companyid');

  if (!customerId || !companyId) {
    console.log('Missing customer ID or company ID.');
    return;
  }

  // Check and set empty values to an empty string
  const locationValue = selectedlocation ? selectedlocation.label : '';
  const areaValue = selectedarea ? selectedarea.label : '';
  const productSelectLabel = selectedproject ? selectedproject.label || '' : '';

  const url = `${BaseAPI}productfilters?company_id=${companyId}&customer_id=${customerId}&productcode=${productNo || ''}&productselect=${productSelectLabel}&location=${locationValue || ''}&area=${areaValue || ''}`;

  fetch(url)
    .then((response) => response.json())
    .then((data) => {
      if (data.data && data.data.length > 0) {
        setData(data.data);
      } else {
        setData([]);
      }
    })
    .catch((error) => {
      console.error('Error fetching data from API:', error);
    });
};


const handleCancel = () => {
  fetchData();
  setProductNo('');
  setSelectedproject(null);
  setSelectedlocation(null);
  setSelectedArea(null);
  
};



useEffect(() => {
  const loadingTimeout = setTimeout(() => {
    setIsLoading(false);
  }, 2000);

  fetchData();
  fetchproduct();
 


  return () => clearTimeout(loadingTimeout);
}, []);


  
  return (
    <div>
      {isLoading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
          <ClockLoader color={"#4e73df"} loading={isLoading} css={spinnerStyle} size={100} />
        </div>
      ) : (
        
        <div>
          <br></br>
           <Row >
              <Col>
                <Row className="mb-4">
                  <Col>
                    <Widget>
                      <div style={{ padding: "20px" }}>
                         <div className="headline-2" style={{color : "blue"}}>Product Search
                          <div style={{ float: "right" }}>
                        
                            <button type="button" className="btn btn-primary" onClick={handleSearch}>
                              <FontAwesomeIcon icon={faSearch}  style={{ marginRight: '5px' }} />
                              Search
                            </button> &nbsp;
                            <button type="button" className="btn btn-primary" onClick={handleCancel}>
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="row" style={{ whiteSpace: 'nowrap' }}>
                        <div className="col-sm-3">

                          <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">Product Code</label>
                          <div style={{ marginLeft: "3px", padding: "10px" }}>
                            <input
                              type="text"
                              className="form-control"
                              id="inputPassword"
                              placeholder="Enter the Product Code"
                              required
                              value={productNo}
                              onChange={(e) => setProductNo(e.target.value)}
                            />
                          </div>
                        </div> 
                        <div className="col-sm-3">
                          <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required">Product Select</label>
                          <div style={{ marginLeft: "3px", padding: "10px" }}>
                          <Select
                                        classNamePrefix="select2-selection"
                                        placeholder="Choose Product..."
                                        title="Asset Form"
                                        options={projectname}
                                        value={selectedproject}
                                        onChange={handleProlectChange}
                                    />
                          </div>
                        </div>
                        <div className="col-sm-3">

                          <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required">Location</label>
                          <div className="row-sm-3" style={{ padding: "10px" }}>
                          <Select
                                        classNamePrefix="select2-selection"
                                        placeholder="Choose Location..."
                                        title="Asset Form"
                                        options={location}
                                        value={selectedlocation}
                                        onChange={handleLocationChange}
                                        key={locationKey}
                                    />

                          </div>
                        </div>
                        <div className="col-sm-3">

                          <label htmlFor="assetCode" className="col-sm-4 col-form-label label-required">Area</label>
                          <div className="row-sm-3" style={{ marginRight: '5px', padding: "10px" }}>
                          <Select
                                        classNamePrefix="select2-selection"
                                        placeholder="Choose Area..."
                                        title="Asset Form"
                                        options={area}
                                        value={selectedarea}
                                        onChange={setSelectedArea}
                                        key={AreaKey}
                                    />
                          </div>

                        </div>
                      </div>



                    </Widget>
                  </Col>
                </Row>
              </Col>
            </Row>

           
          <Row>
            <Col>
              <Row className="mb-4">
                <Col>
                  <Widget>
                    <div style={{ padding: "20px" }}>
                       <div className="headline-2" style={{color : "blue"}}>Product View</div>
                    </div>
                    <div className="widget-table-overflow">
                      <Table className="table-striped table-borderless table-hover" responsive>
                        <thead>
                          <tr style={{ whiteSpace: 'nowrap' }}>
                            {/* <th>id</th> */}
                            <th>Product Code</th>
                            <th>Product</th>
                            <th>location</th>
                            <th>Area</th>
                            <th>QR Code</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
            {searchQuery && filteredData && filteredData.length > 0 ? (
              filteredData.map((item, index) => (
                // Render table rows based on filteredData
                <tr key={index.id}>
                  {/* Render table cells based on your data */}
                  {/* Example: */}
                  <td>{item.productref}</td>
                  <td>{item.productname}</td>
                  <td>{item.AssignDesc}</td>
                  <td>{item.area}</td>
                  <td>
                    {item.prodqrcode ? (
                      <img
                        src={`data:image/png;base64,${item.prodqrcode}`}
                        alt="QR Code"
                        style={{ maxWidth: '80px', maxHeight: '40px' }}
                        className="zoom-in-Qr"
                      />
                    ) : (
                      <span>No QR code available</span>
                    )}
                  </td>
                  <td>
                    <img
                      type="button"
                      src={Printbutton}
                      alt="edit"
                      style={{ width: '35px', height: '35px' }}
                      className='zoom-in-icone'
                      onClick={() => handlePrint(item)}
                    />
                  </td>
                </tr>
              ))
            ) : (
              data && data.length > 0 ? (
                data.slice(secondTableCurrentPage * pageSize, (secondTableCurrentPage + 1) * pageSize).map((item, index) => (
                  // Render table rows based on the complete dataset (data)
                  <tr key={index.id}>
                    {/* Render table cells based on your data */}
                    {/* Example: */}
                    <td>{item.productref}</td>
                    <td>{item.productname}</td>
                    <td>{item.AssignDesc}</td>
                    <td>{item.area}</td>
                    <td>
                      {item.prodqrcode ? (
                        <img
                          src={`data:image/png;base64,${item.prodqrcode}`}
                          alt="QR Code"
                          style={{ maxWidth: '80px', maxHeight: '40px' }}
                          className="zoom-in-Qr"
                        />
                      ) : (
                        <span>No QR code available</span>
                      )}
                    </td>
                    <td>
                      <img
                        type="button"
                        src={Printbutton}
                        alt="edit"
                        style={{ width: '35px', height: '35px' }}
                        className='zoom-in-icone'
                        onClick={() => handlePrint(item)}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" style={{ textAlign: "center", color: "red" }}>
                    {searchQuery ? "No matching data available" : "No data available"}
                  </td>
                </tr>
              )
            )}
          </tbody>
                      </Table>
                      <PaginationComponent />
                    </div>
                  </Widget>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      )}
    </div>
  )
}

const spinnerStyle = css`
display: block;
margin: 0 auto;
`;
export default Product;
